import Vue from "vue";

Vue.use(require("vue-pusher"), {
  api_key: "57df89dd0f9eae07d393",
  options: {
    cluster: "ap1"
  }
});
